<template>
  <div>
    <h1>Pregledi</h1>
    <div class="filters">
      <div class="search-filters">
        <v-autocomplete
          label="Doktori"
          v-model="filters.doctors"
          :items="allDoctors"
          small-chips
          deletable-chips
          multiple
        ></v-autocomplete>
        <v-autocomplete
          label="Pacijenti"
          v-model="filters.patients"
          small-chips
          deletable-chips
          :no-data-text="
            searchPatients ? 'Nema rezultata' : 'Unesite ime/prezime pacijenta'
          "
          multiple
          cache-items
          :items="patients"
          :search-input.sync="searchPatients"
          :loading="loadingPatients"
        ></v-autocomplete>
      </div>
      <div class="treatment-filters">
        <v-checkbox
          v-for="(treatment, index) in allTreatments"
          :key="index"
          v-model="filters.treatments"
          :label="treatment"
          :value="treatment"
        ></v-checkbox>
      </div>
      <div class="per-page-filter">
        <v-select
          v-model="filters.perPage"
          :items="[10, 20, 50, 100]"
          label="Rezultata po stranici"
        ></v-select>
      </div>
      <div class="table-buttons">
        <v-btn
          icon
          @click="isGrid = false"
          :color="!isGrid ? 'teal lighten-1' : ''"
          ><v-icon>mdi-table</v-icon></v-btn
        >
        <v-btn
          icon
          @click="isGrid = true"
          :color="isGrid ? 'teal ligthen-1' : ''"
          ><v-icon>mdi-view-grid-outline</v-icon></v-btn
        >
      </div>
    </div>

    <div v-if="!loadingAppointments">

      <div class="appointments-container" >
        <appointment-card
        class="appointment"
        v-for="appointment in appointments"
        :key="appointment.id"
        :appointment="appointment"
        ></appointment-card>
      </div>
      <v-pagination v-model="page" :length="numPages"></v-pagination>
    </div>
    <div class="appointments-container" v-else>
      <Loader></Loader>
    </div>
  </div>
</template>

<script>
import AppointmentCard from "../components/AppointmentCard.vue";
import Loader from "../components/Loader.vue";

export default {
  components: { AppointmentCard, Loader },
  data() {
    return {
      appointments: [],
      allDoctors: [],
      patients: [],
      allTreatments: [],
      filters: {
        doctors: [],
        patients: [],
        treatments: [],
        perPage: 50,
      },
      loadingPatients: false,
      searchPatients: null,
      loadingAppointments: false,
      isGrid: true,
      page: 1,
      numPages: 1,
    };
  },
  methods: {
    async search(query) {
      console.log("AYOOO");
      this.loadingPatients = true;
      const res = await this.$http.patients.search(query, 1, 20);
      this.loadingPatients = false;
      this.patients = res.data.map((patient) => {
        return {
          text: patient.firstname + " " + patient.lastname,
          value: patient.id,
        };
      });
    },
  },
  mounted: async function() {
    const doctorsRes = this.$http.doctors.getAll(50, 0);
    const appointmentsRes = this.$http.appointments.getAll(
      this.filters.perPage,
      1,
      JSON.stringify({})
    );
    const treatmentsRes = this.$http.treatments.getAll(50, 0);
    this.loadingAppointments = true;
    const [doctors, appointments, treatments] = await Promise.all([
      doctorsRes,
      appointmentsRes,
      treatmentsRes,
    ]);
    this.allDoctors = doctors.data.map((doctor) => {
      return {
        text: doctor.firstname + " " + doctor.lastname,
        value: doctor.id,
      };
    });
    this.appointments = appointments.data.appointments;
    this.loadingAppointments = false;
    this.numPages = Math.ceil(appointments.data.count / this.filters.perPage);

    this.allTreatments = treatments.data;

    // console.log(res);
  },
  watch: {
    filters: {
      async handler(newValue) {
        console.log(newValue);
        this.loadingAppointments = true;
        const res = await this.$http.appointments.getAll(
          this.filters.perPage,
          1,
          JSON.stringify(newValue)
        );
        this.numPages = Math.ceil(res.data.count / this.filters.perPage);
        this.appointments = res.data.appointments;
        this.loadingAppointments = false;
      },
      deep: true,
    },
    page: {
      async handler(newValue) {
        this.loadingAppointments = true;
        const res = await this.$http.appointments.getAll(
          this.filters.perPage,
          newValue,
          JSON.stringify(this.filters)
        );
        this.appointments = res.data.appointments;
        this.loadingAppointments = false;
      },
    },
    searchPatients: {
      handler(newValue) {
        this.search(newValue);
      },
    },
  },
};
</script>

<style scoped>
.filters {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: white;
}

.search-filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.treatment-filters {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: center; */
  gap: 10px;
}

.appointments-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  /* height: 100vh; */
}

.appointment {
  width: 30%;
  /* height: 10%; */
  max-height: 302px;
}

.per-page-filter {
  width: 10%;
}

@media only screen and (max-width: 600px) {
  .appointment {
    width: 75%;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1250px) {
  .appointment {
    width: 45%;
  }
}
</style>
